import { useDispatch, useSelector } from 'react-redux';
import { getRequestFeedback, getRequestFeedbackSent } from '../../app/appSelectors';
import { useEffect, useMemo } from 'react';
import { locationSlice } from '../Location/locationReducer';
import { LOCATION_COMPONENTS_SEARCH_PARAMS, LOCATION_NAMES } from '../Location/locationConstants';
import { useLocation } from 'react-router';
import { MODALS_NAME } from '../Modals/modalsConstants';
import { MOBILE_SLIDER_PAGES_IDS } from '../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants';
import useRefCallback from '../../hooks/useRefCallback';

function RequestFeedbackProvider() {
    const dispatch = useDispatch();
    const requestFeedback = useSelector(getRequestFeedback);
    const requestFeedbackSent = useSelector(getRequestFeedbackSent);
    const location = useLocation();
    const isRequestFeedbackOpened = useMemo(() => {
        const urlSearchParams = new URLSearchParams(location.search);
        const [modals, slides] = [urlSearchParams.getAll(LOCATION_COMPONENTS_SEARCH_PARAMS.MODAL), urlSearchParams.getAll(LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE)];
        return modals.includes(MODALS_NAME.REQUEST_FEEDBACK) || slides.includes(MOBILE_SLIDER_PAGES_IDS.REQUEST_FEEDBACK);
    }, [location.search]);

    const openRequestFeedback = useRefCallback(() => {
        if (isRequestFeedbackOpened) return;
        dispatch(locationSlice.actions.addLocationAction({ name: LOCATION_NAMES.REQUEST_FEEDBACK }));
    });

    useEffect(() => {
        if (!requestFeedback || requestFeedbackSent) return;
        openRequestFeedback();
    }, [requestFeedback, requestFeedbackSent, openRequestFeedback]);

    return null;
}

export default RequestFeedbackProvider;
